import React from "react";
import { useTranslation } from 'react-i18next';

export default function Highlights() {
  const { t } = useTranslation();

  return (
    <div>
      <div className="technology-parth">
        <h1 className="technology-header">{t("elantra.technology-header1")}</h1>
        <img
          src="https://www.hyundai.com/content/dam/hyundai/ww/en/images/find-a-car/pip/cars/elantra-cn7/2023/highlights/elantra-highlights-sophisticated-pc.jpg"
          alt="sonata-i"
        />
      </div>
      <div className="technology-parth technology-sec-part">
        <h1 className="technology-header">
        {t("elantra.technology-header2")}
        </h1>
        <img
          src="https://www.hyundai.com/content/dam/hyundai/ww/en/images/find-a-car/pip/cars/elantra-cn7/2023/highlights/elantra-highlights-an-open-front-door-pc.jpg"
          alt="sonata-i"
        />
      </div>
      <div className="technology-parth">
        <h1 className="technology-header">{t("elantra.technology1")}</h1>
        <p className="paragraph-text">
        {t("elantra.technology2")}
        </p>
        <img
          src="https://www.hyundai.com/content/dam/hyundai/ww/en/images/find-a-car/pip/cars/elantra-cn7/2023/highlights/gallery/elantra-highlights-gallery-with-a-man-13-pc.jpg"
          alt="sonata-i"
        />
      </div>

      <div className="technology-parth technology-sec-part">
        <h1 className="technology-header">
        {t("elantra.technology3")}
        </h1>
        <p className="paragraph-text">
        {t("elantra.technology4")}
        </p>
        <img
          src="https://www.hyundai.com/content/dam/hyundai/ww/en/images/find-a-car/pip/cars/elantra-cn7/2023/highlights/gallery/elantra-highlights-gallery-rear-07-pc.jpg"
          alt="sonata-i"
        />
      </div>
      <div className="technology-parth technology-sec-part">
        <h1 className="technology-header">
        {t("elantra.technology5")}
        </h1>
        <p className="paragraph-text">
        {t("elantra.technology6")}
        </p>
        <img
          src="https://www.hyundai.com/content/dam/hyundai/ww/en/images/find-a-car/pip/cars/elantra-cn7/2023/highlights/gallery/elantra-highlights-gallery-on-the-road-10-pc.jpg"
          alt="sonata-i"
        />
      </div>
    </div>
  );
}
